import React from "react";
import {Button, Col, Divider, Form, Modal, Row} from "antd";
import {checkSnils} from "../Checkers";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import moment from "moment";
import {withFormExt} from "./RgControls";

export const defaultSorter = (column) => (a, b) => {
    const rKey = column.key || column.dataIndex
    return a[rKey] == b[rKey] ? 0 : (a[rKey] > b[rKey] ? 1 : -1)
}

export const IconPopup = ({Icon, twoToneColor, children}) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {setOpen(false)}
    console.log(Icon)
    return (<>
        <Icon
            onClick={() => setOpen(true)}
            twoToneColor={twoToneColor}
            style={{ fontSize: '20px'}}
        />
        <Modal
            visible={open}
            onOk={handleClose}
            onCancel={handleClose}
            width={1000}
        >
            {children}
        </Modal>
    </>)
}

const doTrim     = (s) => (s.toString() || "").trim().replaceAll('-', '').replaceAll('–', '')
const removeSpec = (s) => (s || "").replaceAll(' ', '').replaceAll('\t', '').replaceAll('-', '')

const getSexFormFamily = (text) =>
{
    if (!text)
        return 0
    text = text.toLowerCase()
    if (text.slice(-2) == 'ов')
        return 1
    if (text.slice(-2) == 'ев')
        return 1
    if (text.slice(-3) == 'ева')
        return 2
    if (text.slice(-3) == 'ова')
        return 2
}

const getSexFromPatronymic = (text) =>
{
    if (!text)
        return 0
    text = text.toLowerCase()
    if (text.slice(-2) == 'ич')
        return 1
    if (text.slice(-2) == 'лы')
        return 1
    if (text.slice(-2) == 'на')
        return 2
    if (text.slice(-2) == 'зы')
        return 2
}

const checkOMS16Number = (num) => {
    const sNum = ('' + num).trim();
    if(sNum.length !== 16) return false;
    const controlNum = parseInt(sNum.substr(-1,1));
    const arrNum = Array.from(sNum.substr(0,15));
    const arrOdd = arrNum.filter( (item, i)=> (i+1) & 1);
    const arrEven = arrNum.filter( (item, i) => !((i+1) & 1));

    const arr2 = arrEven.join("") + (parseInt(arrOdd.join(""))*2);


    const arrSum = Array.from("" + arr2).reduce((acc, item) => acc + parseInt(item), 0);
    console.log("ch", arrOdd, arrEven, arr2, arrSum)
    const lastNumber = (""+arrSum).substr(-1);
    const controlNumResult = lastNumber == 0 ? lastNumber : 10 - lastNumber;
    return controlNum == controlNumResult;
}

// проверка ИНН
function isInnValid(inn){
    inn = String(inn).replace(/[^0-9]+/g, '').split('');
    if ( inn.length == 10 ) {
        return inn[9] == String(((
            2*inn[0] + 4*inn[1] + 10*inn[2] +
            3*inn[3] + 5*inn[4] +  9*inn[5] +
            4*inn[6] + 6*inn[7] +  8*inn[8]
        ) % 11) % 10);
    }
    else if ( inn.length == 12 ) {
        return inn[10] == String(((
            7*inn[0] + 2*inn[1] + 4*inn[2] +
            10*inn[3] + 3*inn[4] + 5*inn[5] +
            9*inn[6] + 4*inn[7] + 6*inn[8] +
            8*inn[9]
        ) % 11) % 10) && inn[11] == String(((
            3*inn[0] +  7*inn[1] + 2*inn[2] +
            4*inn[3] + 10*inn[4] + 3*inn[5] +
            5*inn[6] +  9*inn[7] + 4*inn[8] +
            6*inn[9] +  8*inn[10]
        ) % 11) % 10);
    }
    return false;
}




// проверка СНИЛС
function isGpsValid(gps){
    gps = String(gps).replace(/[^0-9]+/g, '');
    if( gps.length == 11 ) {
        var checksum = 0;
        for( var i = 0; i < 9; i++ ) {
            checksum += parseInt(gps.charAt(i)) * (9 - i);
        }
        if( checksum > 101 ) {
            checksum = checksum % 101;
        }
        if( checksum == 100 || checksum == 101 ) {
            checksum = 0;
        }
        return checksum == parseInt(gps.substr(9));
    }
    return false;
}

// проверка ОГРН и ОГРНИП
function isOgrnValid(ogrn) {
    ogrn = String(ogrn).replace(/[^0-9]+/g, '');
    if(ogrn.length == 13) {
        // ОГРН
        return ogrn[12] == (parseInt(ogrn.slice(0, -1)) % 11).toString().slice(-1);
    }
    else if(ogrn.length == 15) {
        // ОГРНИП
        return ogrn[14] == (parseInt(ogrn.slice(0, -1)) % 13).toString().slice(-1);
    }
    return false;
}

export const RgRules = {

    require: (label, warningOnly) =>
        ({
            required: true,
            warningOnly: !!warningOnly,
            message: !warningOnly ? `Поле ${label} обязательно` : `Значение поля ${label} предполагается (пустое значение допустимо)`,
            transform: doTrim  }),
    onlyRus: () => ({
        message: 'Допустимо использование только русских букв, а также знаков пробела, -, '
    }),
    snils: () =>
        ({
            validator: (_, value) => !value || checkSnils(removeSpec(value)) ? Promise.resolve(): Promise.reject(new Error('Поле должно быть содержать корректный СНИЛС'))}),
    notZero: (label, warningOnly) => ({
        warningOnly: !!warningOnly,
        validator: (_, value) => (value > 0) ? Promise.resolve(): Promise.reject(new Error(`Значение поля ${label} предполагается (значение неизвестно допустимо)`)), transform: doTrim}),
    sexCheck: () =>
        ({getFieldValue}) => ({
            warningOnly: true,
            validator: (_, value) => {
                console.log('get check')
                const family = getFieldValue('FAMILY')
                const patronymic = getFieldValue('PATRONYMIC')
                const sexFormFamily = getSexFormFamily(family)
                const sexFromPatronymic = getSexFromPatronymic(patronymic)
                if (sexFormFamily && sexFromPatronymic && (sexFormFamily != sexFromPatronymic))
                    return Promise.reject("Данные ФИО вероятно введены с ошибкой")
                if (sexFromPatronymic && (value != sexFromPatronymic))
                    return Promise.reject("Данные поля Пол не совпадают с ожидаемым значением на основании ФИО")
                if (sexFormFamily && (value != sexFormFamily))
                    return Promise.reject("Данные поля Пол не совпадают с ожидаемым значением на основании ФИО")
                return Promise.resolve()
            }
        }),
    oms: () => ({
        warningOnly: true,
        validator: (_, value) => (checkOMS16Number(value) ? Promise.resolve() : Promise.reject('Контрольня сумма полиса ОМС некорректна')),
        transform: removeSpec
    }),
    beforeNow: (label) => ({
        validator: (_, value) => {

            console.log('v', value)
            console.log('m', moment())
            console.log('q', moment().isBefore(value))
            return moment().isBefore(value) ? Promise.reject(`Дата указанная в поле ${label} ещё не настпуила`) : Promise.resolve()
        }
    }),
    afterNow: (text) => ({
        validator: (_, value) => value && moment().isAfter(value) ? Promise.reject(text): Promise.resolve()
    }),
}

export const getLocalField = (form, fieldInList, prefix) => typeof prefix === "string" ? (localFieldName) => form.getFieldValue([prefix, fieldInList.name, localFieldName]) :
    (localFieldName) => form.getFieldValue(prefix.push(fieldInList.name).push(localFieldName))

export const shouldUpdateMask = (form, fieldInList, prefix, field) => (prevValues, curValues) =>
    console.log("fg", prevValues[prefix][fieldInList.name][field] !== curValues[prefix][fieldInList.name][field]) || prevValues[prefix][fieldInList.name][field] !== curValues[prefix][fieldInList.name][field]

export const RgList = ({label, labelAdd, form, span, data, name, Component, initialValue, showDivider}) => {
    const subform = ({field, remove, showDivider, fieldsCount, form}) => {
        return <Row gutter={6}>
            <Col span={23}>
                <Component field={field} data={data} form={form}/>
            </Col>
            <Col span={1}>
                    <MinusCircleOutlined onClick={() => remove(field.name)} />
            </Col>
            {showDivider && field?.name != fieldsCount - 1 ? <Divider dashed/> : ''}
        </Row>}

    const frm = <Row>
        <Divider>{label}</Divider>
        <Col span={24}>
            <Form.List name={name} initialValue={initialValue} >
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(field => subform({field, form, remove, showDivider, fieldsCount: fields.length}))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                {labelAdd}
                            </Button>
                        </Form.Item>

                    </>
                )}
            </Form.List>
        </Col>
    </Row>
    return withFormExt(frm, span)
}
